// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"73":"lecturapendiente","411":"lecturacliente","418":"listar","949":"clientependiente"}[chunkId] + "." + {"73":"f24319e1","411":"4c0cf9ea","418":"4c4806fb","949":"387e9318"}[chunkId] + ".css";
};